module.exports = __webpack_public_path__ + "static/img/BrechtGeorge_NB3-p127_lateJuly1959.9107699.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/BrechtGeorge_NB3-p127_lateJuly1959.jpg
// module id = nzQc
// module chunks = 0